import { useState } from "react";

import { Badge } from "@src/components/Badge";
import { Button } from "@src/components/Button";
import { Select } from "@src/components/Select";
import { Timer } from "@src/components/Timer";

import { useMeuPlayState } from "@src/states/meuplay";

import {
  getMemorizedSessions,
  sessionTitle,
  setPendingSwitch,
} from "@src/utils/sessions";

import "./style.less";
import type { LoginInfoProps } from "./types";

export function LoginInfo({ logged_in_as, logout }: LoginInfoProps) {
  // Lidas uma vez: a lista não muda enquanto o player está aberto.
  const [sessions] = useState(getMemorizedSessions);

  // A sessão no ar sai do estado (e não de props) porque a identidade inclui o
  // CNPJ: a mesma rádio pode estar memorizada com CNPJs diferentes.
  const loginFormData = useMeuPlayState((state) => state.loginFormData);
  const current = sessions.find(
    (session) =>
      session.idRadio === loginFormData?.idRadio &&
      (session.loginFormData.cnpj || "") === (loginFormData?.cnpj || ""),
  );

  // Sem o que alternar, ainda assim identifica a rádio no ar — `logged_in_as`
  // sozinho não diz QUAL rádio está tocando. Aqui há espaço para duas linhas,
  // então nada de pipe: o separador é a quebra (ver `sessionTitle`).
  const label = current?.label || loginFormData?.idRadio || "";
  const detail = current?.detail || logged_in_as || "";

  return (
    <Badge className="LoginInfo-component">
      <Timer />
      {current && sessions.length > 1 ? (
        <Select
          className="sessions"
          value={current.key}
          title="Alternar sessão"
          onChange={(event) => {
            const target = event.target.value;
            if (target === current.key) return;
            // O login que conclui a troca acontece na tela de login: aqui só
            // registramos o alvo e saímos da sessão atual.
            setPendingSwitch(target);
            logout();
          }}
        >
          {sessions.map((session) => (
            <option key={session.key} value={session.key}>
              {sessionTitle(session)}
            </option>
          ))}
        </Select>
      ) : (
        <span className="current">
          {label}
          {detail && <span className="detail">{detail}</span>}
        </span>
      )}
      <Button type="button" onClick={logout}>
        Sair
      </Button>
    </Badge>
  );
}
